module.exports = __webpack_public_path__ + "img/RIDF_laurels.4b87deae.png";